import React from 'react';
import { DashboardItemData, DashboardZone } from 'framework/ui/dashboard';
import { HealthZone, StaffingDataType, STAFFING_PRIORIRY_ZONES_ALIASES } from 'domain/shared/staffing';
import { ZONE_DESCRIPTIONS, ZONE_LABELS } from 'domain/staffing/dashboard/constants';
import { useStaffingZoneAccentColor } from 'domain/staffing/dashboard/useStaffingZoneAccentColor';
import TeamProjectItem from './StaffingProjectItem';

interface StaffingDashboardZoneProps {
  zone: HealthZone;
  projects?: StaffingDataType[];
  onProjectUpdate?: (project: StaffingDataType) => void;
}

const StaffingDashboardZone: React.FC<StaffingDashboardZoneProps> = ({ zone, projects = [], onProjectUpdate }) => {
  const accentColor = useStaffingZoneAccentColor(zone);

  const zoneConfig = {
    key: zone,
    title: ZONE_LABELS[zone],
    description: ZONE_DESCRIPTIONS[zone],
    accentColor,
    filterFn: (item: DashboardItemData) => {
      const project = item as StaffingDataType;
      const backendZone = project.staffingRisk?.priority || STAFFING_PRIORIRY_ZONES_ALIASES.SAFE;
      return backendZone === zone;
    },
  };

  return (
    <DashboardZone
      zone={zoneConfig}
      items={projects}
      renderItem={(item: DashboardItemData, updateItem) => {
        const project = item as StaffingDataType;

        return (
          <TeamProjectItem
            project={project}
            onUpdate={updatedProject => {
              updateItem(updatedProject);
              onProjectUpdate?.(updatedProject);
            }}
          />
        );
      }}
      sx={{
        mb: 2,
      }}
    />
  );
};

export default StaffingDashboardZone;
